export default "/kiban/_next/static/images/rigidFlexPcb-3cea654ec34a525b90ac1af217cf3d57.png";